import React, { useEffect, useState, useRef } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import ThemeTable from "../component/ThemeTable";
import PurchaseService from "../services/Purchase";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import Form from "react-bootstrap/Form";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import toast from "react-hot-toast";
import SelectDropDown from "../component/SelectDropDown";
import NoData from "../component/NoData";
import { addPurchase } from "../redux/slices/currentPurchase";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "antd";
import { Modal } from "react-bootstrap"; 
import { FaFlag } from "react-icons/fa";
import { Flag } from 'lucide-react';


import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const dateFormat = 'YYYY-MM-DD';

const MyAlliedPurchase = () => {
  const dispatch = useDispatch();
  const currentBrand = useSelector(
    state => state.userTypeSlice.currentBrand,
  );
  const allStatus = [
    { id: "pending", title: "Pending", pageNo: 1 },
    { id: "accepted", title: "Approved / Rejected", pageNo: 1 },
  ];
  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");

  const isHierDesc = userInfo?.description || null;  
  const [loading, setLoading] = useState(true);
  const [btnDisable, setBtnDisable] = useState(false)
  const [purchaseList, setIsPurchaseList] = useState([]);
  const [isDataFound, setIsDataFound] = useState(false);
  const [conversionFactor, setConversionFactor] = useState(0.5);
  const tseSectionBlock = isHierDesc === "TSE";
  const [isSearchMobile, setIsSearchMobile] = useState("");
  const [isSearchName, setIsSearchName] = useState("");
  const [isSearchSingleData, setIsSearchSingleData] = useState(false);
  const [isSearchPurchaseDate, setIsSearchPurchaseDate] = useState("");
  const [isActionBTNClicked, setIsActionBTNClicked] = useState(false);
  const [isTableDataFound, setIsTableDataFound] = useState(false);
  const [allMarked, setAllMarked] = useState([]);
  const [allMItems, setAllMItems] = useState([]);
  const [status, setStatus] = useState(allStatus[0]);
  const [showYesNoModal, setShowYesNoModal] = useState(false);
  const [tseGeoLocation,setTseGeoLocation] = useState([]);
  // const [pageNo, setPageNo] = useState(1);
  const [allDealers, setAllDealers] = useState([]);
  const [selectedDealers, setSelectedDealers] = useState({id: '', title: ''});

  const [defaultDatePicker, setDefaultDatePicker] = useState(false);
  const [limitDays, setLimitDays] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [flag, setFlag] = useState(false);
  const [inputbox, setInputbox] = useState(false);
  const [showRevokeBox, setShowRevokeBox] = useState(false);
  const [revokeReason, setRevokeReason] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOpenModal = (description) => {
    setModalData(description);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    const savedSearchMobile = localStorage.getItem("isSearchMobile");
    const savedSearchName = localStorage.getItem("isSearchName");
    const savedSearchPurchaseDate = localStorage.getItem(
      "isSearchPurchaseDate"
    );

    if (savedSearchMobile) setIsSearchMobile(savedSearchMobile);
    if (savedSearchName) setIsSearchName(savedSearchName);
    if (savedSearchPurchaseDate)
      setIsSearchPurchaseDate(savedSearchPurchaseDate);
  }, []);

  useEffect(() => {
    localStorage.setItem("isSearchMobile", isSearchMobile);
    localStorage.setItem("isSearchName", isSearchName);
    localStorage.setItem("isSearchPurchaseDate", isSearchPurchaseDate);
  }, [isSearchMobile, isSearchName, isSearchPurchaseDate]);

  //Conversion
  const ConversionFactorData = async () => {
    const token = localStorage.getItem("access_token");
    try {
      const ConversionDataResponse = await PurchaseService.conversionFactor(
        token
      );
      if (ConversionDataResponse.success == true) {
        setConversionFactor(
          parseFloat(ConversionDataResponse.response.conversionDetails)
        );
      }
      if (!isNaN(conversionFactor)) {
        setConversionFactor(conversionFactor);
      }
    } catch (e) {
      console.log("ConversionError", e);
    }
  };

  function onChecked(item) {
    console.log(item);
    if (allMarked.includes(item["Transaction Id"])) {
      const newList = allMItems.filter(i => i.sale_id != item["Transaction Id"])
      setAllMItems(newList);
      const list = allMarked.filter((i) => i != item["Transaction Id"]);
      setAllMarked(list);
    } else {
      if (allMarked.length > 14) {
        toast.error("Cannot approve more than 5 items");
        return;
      }
      console.log([...allMarked, item["Transaction Id"]]);
      setAllMarked((p) => [...p, item["Transaction Id"]]);
      setAllMItems(p => [...p, {...item.Select.item}])
    }
    const updatedPList = purchaseList.map(sale => {
      console.log(sale["Transaction Id"] === item["Transaction Id"])
      if(sale["Transaction Id"] === item["Transaction Id"]) {
        console.log("upl", allMarked, sale["Transaction Id"], item["Transaction Id"])
        const { Select, ...rest } = sale;
        return ({Select: {
          isChecked: !allMarked.includes(item["Transaction Id"]),
          saleStatus: item.Status.props.children[0]
        }, ...rest})
      }
      return sale;
    })

    console.log("upl", updatedPList)
    setIsPurchaseList(updatedPList);
  }

  // function rePurchaseHandler(item) {
  //   console.log(item);
  //   dispatch(addPurchase({currentPurchase: item}));
  //   navigate('/purchase-registration');
  // }
  function rePurchaseHandler(item) {
    console.log(item);
    dispatch(addPurchase({ currentPurchase: item }));
  
    navigate('/allied-product-registration', {
      state: {
        dealerContactId: item.dealer_id, 
        ...item, 
      }
    });
  }
  
  //Purchase List
  const PurchaseListFetchData = async (
    searchText,
    fromDate,
    toDate,
    searchByInfName,
    brandId
  ) => {
    try {
      const contactId = userInfo.dcm_contacts_id;
      setLoading(true)
      const payload = {
        created_from: "",
        created_to: "",
        root_id: "",
        search_type: "",
        searchValue: "",
        org_id: 2,
        contact_id: Number(contactId),
        contact_title: "",
      };
      const responsePurchaseList =
        await PurchaseService.myPurchaseAlliedItemsUsingFilter(
          isHierDesc === "TSE" ? "" : brandId,
          searchText,
          fromDate,
          toDate,
          status.id,
          selectedDealers?.id,
          searchByInfName,
          payload,
          50,
          status.pageNo,
        );
        console.log("responsePurchaseList", responsePurchaseList);
        
        setLoading(false)
      if(responsePurchaseList.response?.exceptionChecker === true) {
        setDefaultDatePicker(true);
      } else {
        setDefaultDatePicker(false);
      }

      if(responsePurchaseList.response?.limitDays === 0) {
        setDefaultDatePicker(true);
      } else {
        const limitDays = parseInt(responsePurchaseList.response?.limitDays)
        setLimitDays(limitDays); 
      }    

      // if(responsePurchaseList.response.saleData.)
      const saleDataRes = responsePurchaseList.response.saleData || [];
      const filteredData = saleDataRes.map((item, index) => {
        if(item.disable_approve_flag && item.disable_approve_flag.name === 'disableApproveFlag') {
          setFlag(true);
          return;
        } 
      });

      if (
        responsePurchaseList.success == true &&
        responsePurchaseList.response.status == true &&
        responsePurchaseList.response.saleData.length > 0
      ) {
        setTseGeoLocation(responsePurchaseList.response.tse_geo_location);
        const filteredData = responsePurchaseList.response.saleData.map(
          (item, index) => {
            const conumptionsData = item.proposed_area * conversionFactor;
            let transationId = item.sale_id;
            let quantityNo = Number(item.tonnage_sold);
            let statusElement;
            if (item.sale_status == 0) {
              statusElement = (
                <>
                  {isHierDesc != "TSE" && (
                    <span className="pendingTxt">Submitted For Approval</span>
                  )}
                  {isHierDesc == "TSE" && (
                    <div className="pendingStatusBlock">
                      <span className="pendingTxt">Pending</span>
                      <button
                        onClick={() => handleCheckNow(item, tseGeoLocation)}
                        className="checkNowBtn"
                      >
                        Check
                      </button>
                    </div>
                  )}
                </>
              );
            } else if (item.sale_status == 1) {
              statusElement = (
                // <>
                // <div className="text-center approvedTxt">
                //   <span className="approvedTxt">Approved</span>
                // </div> 
                // <button 
                //   onClick={() => rePurchaseHandler(item)} 
                //   className="checkNowBtn"
                // >
                //   Revoke
                // </button>
                // </>
                <div className="approvedStatusBlock">
                {/* <span className="approvedTxt">Approved</span> &nbsp; */}
                <div className="text-center approvedTxt">
                  <span className="approvedTxt">Approved</span>
                </div>
                {/* {isHierDesc == "TSE" && <button
                  onClick={() => handleRevoke(item)}
                  className="checkNowBtn"
                >
                  Revoke
                </button>} */}
              </div>
              );
            } else if (item.sale_status == 2) {
              statusElement = (
                <div className="text-center rejectedTxt">
                  <span className="rejectedTxt">Rejected</span>
                </div>
              );
            } else if (item.sale_status == 4) {
              statusElement = (
                <div className="text-center purpleTxt">
                  <span className="purpleTxt">Sent for RTSM Approval</span>
                </div>
              );
            }
            const dateTime = new Date(item.created_at);
            const formattedDateTime = dateTime.toLocaleString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            });
            console.log("ss", formattedDateTime);
            if (isHierDesc == "TSE")
              return {
                Select: {
                  isChecked: false,
                  saleStatus: item.sale_status,
                  item: item
                },
                "Transaction Id": transationId,
                "Purchase Date": item.sale_date,
                Quantity: quantityNo.toFixed(2),
                Description: item.product_description,
                // "Enrolled Date": formattedDateTime,
                // "Proposed Area (Sq ft.)": item.proposed_area,
                "Total build-up area": item.proposed_area,
                "Approved Area (Sq ft.)":
                // "Approved build-up area":
                  item.approved_area == null
                    ? item.proposed_area
                    : item.approved_area,
                "Total Consumptions": conumptionsData,
                // "Customer Name": item.customer_name,
                "Site owner name": item.customer_name,
                "Site owner number": item.customer_mobile,
                Dealer: (
                  <div>
                    {item.dealer_name}
                    <span className="dealerId">{item.id_extern01}</span>
                  </div>
                ),
                // ...(tseSectionBlock && { "Purchased By": item.full_name }),
                "Contractor Name": isHierDesc == "TSE" ? item.full_name : undefined,
                "Contractor Number": isHierDesc == "TSE" ? item.number : undefined,
                // Capping: (
                //   <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                //     {Array.isArray(item.capping_flag_arr) && item.capping_flag_arr.length > 0 ? (
                //       item.capping_flag_arr.map((cap, index) => {
                //       const colorName = cap.name.replace("flag", "").toLowerCase();

                //       return (
                //         <button
                //           key={index}
                //           onClick={() => handleOpenModal(cap.description)}
                //           className={`flag-circle ${colorName}`}
                //           title={colorName}
                //         >
                //           <Flag size={16} />
                //         </button>
                //       );
                //     })
                //     ) : (
                //       <span>-</span>
                //     )}
                //   </div>
                // ),
                Status: statusElement,
              };
            else {


              const obj = {
                "S No.": index + 1,
                "Transaction Id": transationId,
                "Purchase Date": item.sale_date,
                Quantity: quantityNo.toFixed(2),
                Description: item.product_description,
                // "Purchase Date": item.sale_date,
                // "Enrolled Date": formattedDateTime,
                // "Proposed Area (Sq ft.)": item.proposed_area,
                "Total build-up area": item.proposed_area,
                "Approved Area (Sq ft.)":
                // "Approved build-up area":
                  item.approved_area == null
                    ? item.proposed_area
                    : item.approved_area,
                "Total Consumptions": conumptionsData,
                // "Customer Name": item.customer_name,
                "Site owner name": item.customer_name,
                // "Site owner number": item.customer_mobile,
                Dealer: (
                  <div>
                    {item.dealer_name}
                    <span className="dealerId">{item.id_extern01}</span>
                  </div>
                ),
                Status: statusElement,
               
              }
              if(item?.sale_status==1) {
                Object.assign(obj, { "Re-Purchase" :   
                <div className="text-center pendingTxt">
                  <span onClick={() => rePurchaseHandler(item)} className="pendingTxt"> Repeat Purchase</span>
                </div>})
              }
              
              return obj ;
            }
          }
        );
        setIsTableDataFound(true);
        setIsDataFound(false);
        if (status.pageNo == 1) setIsPurchaseList([...filteredData]);
        if (status.pageNo > 1)
          setIsPurchaseList((p) => [...p, ...filteredData]);
        // setLoading(false);
        setIsSearchSingleData(false);
      } else if (
        responsePurchaseList.success == true &&
        responsePurchaseList.response.status == true &&
        responsePurchaseList.response.saleData.length == 0
      ) {
        // toast.error("No more data available");
        setIsTableDataFound(false);
        if(status.pageNo > 1) {
          setIsTableDataFound(true);
        } else {
          setIsPurchaseList([]);
        }
        if(status.pageNo > 1 ){toast.error("No more data available");}
        setIsSearchSingleData(true);
        setBtnDisable(true);
        // setLoading(false);
      } else {
        setIsTableDataFound(false);
        if (status.pageNo == 1) {
          setIsPurchaseList([]);
        }
        setIsSearchSingleData(true);
        // setLoading(false);
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };
  const tseGeoLocationRef = useRef([]);
  useEffect(() => {
    console.log("Updated tseGeoLocation:", tseGeoLocation);
    tseGeoLocationRef.current = tseGeoLocation;
}, [tseGeoLocation]);

const navigate = useNavigate();
const handleCheckNow = (item) => {
  navigate(`/purchase-approval-allied/${item.sale_id}`, { state: {...item,tseGeoLocation: tseGeoLocationRef.current} });
};

const handleRevoke = (item) => {
  setSelectedItem(item);
  setShowRevokeBox(true);
}
const handleRevokeSubmit = async () => {
  if (!revokeReason.trim()) {
    toast.error("Please enter a revoke reason");
    return;
  }
  try {
    const payload = {
      sale_id: selectedItem.sale_id,
      reason: revokeReason,
    };
    const response = await PurchaseService.revokePurchase(payload);
    if (response.success) {
      toast.success("Purchase revoked successfully");
      setShowRevokeBox(false);
      setRevokeReason("");
      setSelectedItem(null);
      handleClear(); 
    } else {
      toast.error(response.response?.message || "Failed to revoke purchase");
    }
  } catch (error) {
    console.error("Revoke error:", error);
    toast.error("Error revoking purchase");
  }
};

const handleRevokeClose = () => {
  setShowRevokeBox(false);
  setRevokeReason("");
  setSelectedItem(null);
};


  // Function to process data after confirmation
  // const processData = (saleData) => {
  //   const filteredData = saleData.map((item, index) => {
  //     const conumptionsData = item.proposed_area * conversionFactor;
  //     let transationId = item.sale_id;
  //     let quantityNo = Number(item.tonnage_sold);
  
  //     let statusElement;
  //     if (item.sale_status == 0) {
  //       statusElement = (
  //         <>
  //           {isHierDesc != "TSE" && (
  //             <span className="pendingTxt">Submitted For Approval</span>
  //           )}
  //           {isHierDesc == "TSE" && (
  //             <div className="pendingStatusBlock">
  //               <span className="pendingTxt">Pending</span>
  //               <button
  //                 onClick={() => handleCheckNow(item)}
  //                 className="checkNowBtn"
  //               >
  //                 Check
  //               </button>
  //             </div>
  //           )}
  //         </>
  //       );
  //     } else if (item.sale_status == 1) {
  //       statusElement = (
  //         <div className="text-center approvedTxt">
  //           <span className="approvedTxt">Approved</span>
  //         </div>
  //       );
  //     } else if (item.sale_status == 2) {
  //       statusElement = (
  //         <div className="text-center rejectedTxt">
  //           <span className="rejectedTxt">Rejected</span>
  //         </div>
  //       );
  //     }
  
  //     const dateTime = new Date(item.created_at);
  //     const formattedDateTime = dateTime.toLocaleString("en-US", {
  //       year: "numeric",
  //       month: "long",
  //       day: "numeric",
  //       hour: "numeric",
  //       minute: "numeric",
  //       second: "numeric",
  //       hour12: true,
  //     });
  
  //     if (isHierDesc == "TSE")
  //       return {
  //         Select: {
  //           isChecked: false,
  //           saleStatus: item.sale_status,
  //           item: item,
  //         },
  //         "Transaction Id": transationId,
  //         Quantity: quantityNo.toFixed(2),
  //         Description: item.product_description,
  //         "Purchase Date": item.sale_date,
  //         "Enrolled Date": formattedDateTime,
  //         "Proposed Area (Sq ft.)": item.proposed_area,
  //         "Approved Area (Sq ft.)":
  //           item.approved_area == null ? item.proposed_area : item.approved_area,
  //         "Total Conumptions (Bags)": conumptionsData,
  //         "Customer Name": item.customer_name,
  //         Dealer: (
  //           <div>
  //             {item.dealer_name}
  //             <span className="dealerId">{item.id_extern01}</span>
  //           </div>
  //         ),
  //         ...(tseSectionBlock && { "Purchased By": item.full_name }),
  //         Status: statusElement,
  //       };
  //     else {
  //       const obj = {
  //         "S No.": index + 1,
  //         "Transaction Id": transationId,
  //         Quantity: quantityNo.toFixed(2),
  //         Description: item.product_description,
  //         "Purchase Date": item.sale_date,
  //         "Enrolled Date": formattedDateTime,
  //         "Proposed Area (Sq ft.)": item.proposed_area,
  //         "Approved Area (Sq ft.)":
  //           item.approved_area == null ? item.proposed_area : item.approved_area,
  //         "Total Conumptions (Bags)": conumptionsData,
  //         "Customer Name": item.customer_name,
  //         Dealer: (
  //           <div>
  //             {item.dealer_name}
  //             <span className="dealerId">{item.id_extern01}</span>
  //           </div>
  //         ),
  //         Status: statusElement,
  //       };
  //       if (item?.sale_status == 1) {
  //         Object.assign(obj, {
  //           "Re-Purchase": (
  //             <button
  //               onClick={() => rePurchaseHandler(item)}
  //               className="checkNowBtn"
  //             >
  //               Repeat Request
  //             </button>
  //           ),
  //         });
  //       }
  //       return obj;
  //     }
  //   });
  
  //   setIsTableDataFound(true);
  //   setIsDataFound(false);
  //   if (status.pageNo == 1) setIsPurchaseList([...filteredData]);
  //   if (status.pageNo > 1) setIsPurchaseList((p) => [...p, ...filteredData]);
  //   setLoading(false);
  //   setIsSearchSingleData(false);
  // };
  
  useEffect(() => {
    ConversionFactorData();
  }, []);
  useEffect(() => {
    console.log("selected", allMarked);
    if (currentBrand.id) {
    PurchaseListFetchData(
      isSearchMobile,
      isSearchPurchaseDate,
      isSearchPurchaseDate,
      isSearchName,
      currentBrand.id
    );
    }
  }, [isHierDesc, isActionBTNClicked, status, currentBrand]);

  // useEffect(() => {
  //   if(purchaseList.length > 0) {
  //     const updatedList = purchaseList.map(item => {
  //       console.log(item)
  //       if(allMarked.includes(item["Transaction Id"].props.children)) {
  //         const uItem = {'Select': <input disabled={item.sale_status != 0 } type="checkbox" id="scales" name="scales" checked={true} onChange={() => onChecked(item)} />, ...item}
  //         return uItem;
  //       } else {
  //         const uItem = {'Select': <input disabled={item.sale_status != 0 } type="checkbox" id="scales" name="scales" checked={false} onChange={() => onChecked(item)} />, ...item}
  //         return uItem;
  //       }
  //     })
  //   }
  // }, [allMarked, purchaseList])

//   const handleCheckNow = (item, tseGeoLocationData) => {
//     navigate(`/purchase-approval/${item.sale_id}`, { 
//         state: { ...item, tseGeoLocation: tseGeoLocationData } 
//     });
// };

  const handleSearchMobile = (e) => {
    setIsSearchMobile(e.target.value.replace(/\D/g, ""));
  };

  const handleSearchName = (e) => {
    setIsSearchName(e.target.value);
  };
  const handlePurchaseDate = (date, dateString) => {
  setIsSearchPurchaseDate(dateString);
};
  const handleSearch = () => {
    setStatus((p) => ({ ...p, pageNo: 1 }));
    // setTimeout(() => {
    //   PurchaseListFetchData(
    //     isSearchMobile,
    //     isSearchPurchaseDate,
    //     isSearchPurchaseDate,
    //     isSearchName,
    //     selectedDealers?.id
    //   );
    //   // fetchDealers();
    // }, 800);
  };
  const handleClear = () => {
      console.log("Clearing...");
      setBtnDisable(false)
      setStatus((p) => ({ ...p, pageNo: 1 }));
      setIsActionBTNClicked(!isActionBTNClicked);
      setIsSearchMobile("");
      setIsSearchName("");
      setIsSearchPurchaseDate("");
      setSelectedDealers({id:''});
      localStorage.removeItem("isSearchMobile");
      localStorage.removeItem("isSearchName");
      localStorage.removeItem("isSearchPurchaseDate");
      localStorage.removeItem("selectedDealers");
  };

  function submitHandler(selectedItem, idx, len, toastId) {
    // if (loading) return;
    // setCheck(p => p + 1);

    if (!selectedItem.dealer_id) {
      toast.error(`Dealer missing for purchase id: ${selectedItem.sale_id}`);
      return;
    }

    console.log(selectedItem);
    let payload = {
      accept_or_reject: "accept",
      reasons: "Confirmed by Technical Services Officer",
      contact_id_contractor: selectedItem.contractor_contact_id,
      sale_id: selectedItem.sale_id,
      other_reason: "",
      customer_name: selectedItem.customer_name,
      mobile_number: selectedItem.number,
      site_name: selectedItem.site_name,
      approved_area: selectedItem.approved_area
        ? selectedItem.approved_area
        : selectedItem.proposed_area,
      dealer_id: selectedItem.dealer_id,
    };
    console.log("payload submit sales", JSON.stringify(payload));
    // setApproveLoader(p => ({...p, state: true}));
    PurchaseService.acceptOrRejectAllied(payload)
      .then((res) => {
        console.log("Submit sales", JSON.stringify(res));
        if (idx == len) {
          toast.dismiss(toastId);
          handleClear()
          setAllMItems([]);
          setAllMarked([]);
        }
        // setApproveLoader(p => ({...p, state: false}));
        if (res.success) {
          if (res.response.salesResult.status) {
            toast.success(`Approved purchase with id ${selectedItem.sale_id}`);
          } else {
            toast.error(
              `purchase with id ${selectedItem.sale_id} : ${res.response.salesResult.message}`
            );
          }
        } else {
          toast.error(
            `purchase with id ${selectedItem.sale_id} : ${res.response.salesResult.message}`
          );
          // toast.show('', {
          //   data: {
          //     isSuccess: false,
          //     heading:
          //       whichBtn == 'accept'
          //         ? getLabelLanguage(selLang, 'approval_failed')
          //         : getLabelLanguage(selLang, 'rejection_failed'),
          //     describe: res.message,
          //   },
          //   onClose: () => {
          //     setReasonDropdown([]);
          //     setCheck(1);
          //     // resetFields();
          //     // navigation.navigate('MyPurchase');
          //   },
          // });
        }
      })
      .catch((err) => {
        console.log("ERR My Purchase submit", err);
        // toast.show('', {
        //   data: {
        //     isSuccess: false,
        //     heading: 'Something went wrong',
        //     describe: err.message,
        //   },
        //   onClose: () => {
        //     setHasReasonField(false);
        //     setReasonDropdown([]);
        //     setSelectedReason({id: '', title: ''});
        //     setCheck(1);
        //   },
        // });
      });
  }

  function approveAll() {
    console.log(allMItems);
    const toastId = toast.loading("Loading...");
    allMItems.forEach((item, index) => {
      console.log(item);
      submitHandler(item, index + 1, allMItems.length, toastId);
    });
  }

  function onLoadMore() {
    setStatus((p) => ({ ...p, pageNo: p.pageNo + 1 }));
  }
  let headers = [];
  if (purchaseList.length > 0) {
    headers = Object.keys(purchaseList[0]).filter(key => purchaseList[0][key] !== undefined);
  }
  console.log("headers", headers);

  //   async function fetchDealers() {
  //     try {
  //       const res = await PurchaseService.getPurchaseApprovalDealer();
  //       console.log('purchase approval dealers', JSON.stringify(res));

  //       if (res.success) {
  //         const dealers = res.response.dealers.map(dealer => ({
  //           id: dealer?.dealer_id,
  //           title:
  //             dealer?.dealer_business_name +
  //             ' ( M : ' +
  //             dealer?.phone_number +
  //             ', SAP Code : ' +
  //             dealer?.id_extern01 +
  //             ')',
  //         }));

  //         setAllDealers(dealers);
  //       }
  //     } catch (err) {
  //       console.log('purchase approval dealers err', err);
  //     }
  //   }

  //   useEffect(() => {
  //   fetchDealers();
  // }, []);

  // header={
  //   hierName === "TSE"
  //     ? "Product -wise Lifting"
  //     : "Points Earned from Products"
  // }
  const today = new Date().toISOString().split("T")[0]; // max
  const fifteenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 15))
      .toISOString()
      .split("T")[0]; // min
  
  const minDate = dayjs(fifteenDaysAgo, "YYYY-MM-DD");
  const maxDate = dayjs(today, "YYYY-MM-DD");
  const disabledDate = (current) => {
    return current < minDate.startOf("day") || current > maxDate.endOf("day");
  };

  return (
    <>
      <BreadCrumbSecttion
        pageTitle={isHierDesc === "TSE" ? "Allied Purchase Approval" : "My Allied Purchase"}
        currentPageName={isHierDesc === "TSE" ? "Allied Purchase Approval" : "My Allied Purchase"}
      />
      <section className="padTop50">
        {allMarked.length > 0 && (
          <Button className="float-footer" onClick={approveAll}>
            Approve All
          </Button>
        )}
        <Container>
          <Row>
            {!isDataFound && (
              <>
                {/* {tseSectionBlock && ( */}
                  <Col xs={12} lg={12}>
                    <div className="searchBoxBlock my-4">
                      <Row className="space-btn">
                      {tseSectionBlock && 
                      <Col xs={12} lg={2}>
                          <InputField
                            inputFieldLabel="Search By Mobile"
                            onChange={handleSearchMobile}
                            value={isSearchMobile}
                          />
                        </Col>}
                        {tseSectionBlock && <Col xs={12} lg={2}>
                          <InputField
                            inputFieldLabel="Search By Name"
                            value={isSearchName}
                            onChange={handleSearchName}
                          />
                        </Col>}
                        {/* {tseSectionBlock &&  <Col xs={12} lg={2}>
                          <Form.Label>Search By Purchase Date</Form.Label>
                          <Form.Control
                            type="date"
                            value={isSearchPurchaseDate}
                            onChange={handlePurchaseDate}
                          />
                        </Col>} */}
                        
                        {/* {tseSectionBlock && defaultDatePicker&& 
                          <Col xs={12} lg={3}>
                            <Form.Label>Search by Purchase Date</Form.Label>
                            <Form.Control
                              type="date"
                              value={isSearchPurchaseDate}
                              onChange={handlePurchaseDate}
                              max={new Date().toISOString().split('T')[0]}
                            />
                          </Col>
                          } */}

                      {tseSectionBlock && <Col xs={12} lg={3}>
                          <Form.Label>Search by Purchase Date</Form.Label>
                          <DatePicker
                            value={
                              isSearchPurchaseDate
                                ? dayjs(isSearchPurchaseDate, dateFormat)
                                : null
                            }
                            format={dateFormat}
                            onChange={handlePurchaseDate}
                            onKeyDown={(e) => e.preventDefault()}
                            className="w-100"
                            style={{ height: "43px" }}
                          />
                        </Col>}

                        <Col xs={12} lg={2}>
                          <SelectDropDown
                            labelName="Filter by status"
                            // requiredStar="*"
                            options={allStatus}
                            setSelectedValue={setStatus}
                            selectedValue={status}
                            // onChange={handleContentDistrictNameChange}
                            page="searchFilter"
                          />
                        </Col>
                        {/* <Col xs={12} lg={2}>
                          <SelectDropDown
                            labelName="Choose Dealer/ARS/Retailer"
                            // requiredStar="*"
                            options={allDealers}
                            setSelectedValue={setSelectedDealers}
                            selectedValue={selectedDealers}
                            // onChange={handleContentDistrictNameChange}
                            page="searchFilter"
                          />
                        </Col> */}
                        {tseSectionBlock && <Col xs={12} lg={3} className="mt-4">
                          <Row className="purchaseSearchBtnWrap">
                            <Col xs={12} lg={6}>
                              <PrimaryGradientButton
                                buttonText="Search"
                                onClick={handleSearch}
                              />
                            </Col>
                            <Col xs={12} lg={6}>
                              <PrimaryOutLineButton
                                outlinebuttonText="Clear"
                                onClick={handleClear}
                              />
                            </Col>
                          </Row>
                        </Col>}
                      </Row>
                    </div>
                  </Col>

                {purchaseList.length === 0 && !loading && <NoData title="No data available" />}
                {purchaseList.length === 0 && loading && <NoData title="Fetching..." />}
                {isTableDataFound && (
                  <Col xs={12} lg={12} className="purchaseListTable">
                    {/* <ThemeTable data={purchaseList} onLoadMore={onLoadMore} /> */}

                    <Table striped bordered hover responsive className="purchaseTable">
                      <thead>
                        <tr>
                          {headers.length > 0 &&
                            headers.map((header, index) => {
                              if(header === "Purchase Date" && !tseSectionBlock) {
                                // return null;
                              }
                              return <th key={index}>{header}</th>
                              })}
                        </tr>
                      </thead>
                      <tbody>
                        {purchaseList.length > 0 &&
                          purchaseList.map((item, index) => {
                            // console.log(item.Select.isChecked);
                            // const keysArray = Object.keys(item);
                            // return (
                            return (<tr
                              key={index}
                              // className={rowClickable ? "cursor-pointer" : ""}
                            >
                              {isHierDesc == "TSE" ? <td ><input
                                disabled={item.Select.saleStatus != 0}
                                type="checkbox"
                                id="scales"
                                name="scales"
                                checked={item.Select.isChecked}
                                onChange={() => onChecked(item)}
                              />
                            </td> : <td ><div>{index+1}</div>
                            </td>}
                            <td
                            
                            >
                              <div>{item["Transaction Id"]}</div>
                            </td>
                            
                            <td>
                              <div>{item["Purchase Date"]}</div>
                            </td>

                            {/* {tseSectionBlock && <td

                            >
                              <div>{item["Purchase Date"]}</div>
                            </td>} */}

                            <td>
                              <div>{item["Quantity"]}</div>
                            </td>
                            <td
                            
                            >
                              <div>{item["Description"]}</div>
                            </td>
                            {/* {tseSectionBlock && <td

                            >
                              <div>{item["Purchase Date"]}</div>
                            </td>} */}
                            {/* <td
                            
                            >
                              <div>{item["Enrolled Date"]}</div>
                            </td> */}
                            <td
                            
                            >
                              <div>{item["Total build-up area"]}</div>
                            </td>
                            <td
                            
                            >
                              <div>{item["Approved Area (Sq ft.)"]}</div>
                            </td>
                            <td
                            
                            >
                              <div>{item["Total Consumptions"]}</div>
                            </td>
                            <td
                            
                            >
                              <div>{item["Site owner name"]}</div>
                            </td>

                            {tseSectionBlock && <td
                            
                            >
                              <div>{item["Site owner number"]}</div>
                            </td>}

                            <td
                            
                            >
                              <div>{item["Dealer"]}</div>
                            </td>

                            {tseSectionBlock && <td
                            
                            >
                              <div>{item["Contractor Name"]}</div>
                            </td>}

                            {tseSectionBlock && <td>
                              <div>{item["Contractor Number"]}</div>
                            </td>

                            }
                            {/* {tseSectionBlock && <td
                            
                            >
                              <div>{item["Capping"]}</div>
                            </td>} */}

                            {/* {tseSectionBlock && <td
                            
                            >
                              <div>{item["Purchased By"]}</div>
                            </td>} */}
                            <td
                            
                            >
                              <div>{item["Status"]}</div>
                            </td>
                            {!tseSectionBlock && item["Re-Purchase"] &&<td
                            
                            >
                              <div>{item["Re-Purchase"]}</div>
                            </td>}
                            
                            </tr>)
                          })}
                      </tbody>
                    </Table>
                    {/* {visibleItemCount < data.length && ( */}

                    {/* {purchaseList.length > 0 && !loading && purchaseList.length % 20 === 0 &&<Container>
                      <Row className="justify-content-center">
                        <Col xs={12} lg={3}>
                          <PrimaryGradientButton
                            disabled={btnDisable}
                            onClick={onLoadMore}
                            buttonText="Show More"
                          />
                        </Col>
                      </Row>
                    </Container>} */}
                    {purchaseList.length > 0 && purchaseList.length % 20 === 0 && (
                  loading ? (
                    <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText="Loading..."
                      />
                    </Col>
                  </Row>
                </Container>
                  ) : (
                    <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        disabled={btnDisable}
                        onClick={onLoadMore}
                        buttonText="Show More"
                      />
                    </Col>
                  </Row>



                </Container>
                  )
                )}
                    {/* )} */}
                  </Col>
                )}
              </>
            )}
          </Row>
        </Container>
        {showRevokeBox && (
          <Modal show={showRevokeBox} onHide={handleRevokeClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Revoke Purchase</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter reason for revoking this purchase"
                  value={revokeReason}
                  onChange={(e) => setRevokeReason(e.target.value)}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <PrimaryGradientButton
                buttonText="Submit"
                onClick={handleRevokeSubmit}
              />
            </Modal.Footer>
          </Modal>
      )}

        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Body>
            <p style={{ fontSize: "14px", color: "#333" }}>{modalData}</p>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
};

export default MyAlliedPurchase;